<template>
  <div class="text-right">
    <div class="hound">
      <img
        class="returns"
        @click="returnBtn"
        src="../../assets/h5/return.png"
        alt=""
      />
      <p>{{ $t("withdrawalLogin.title2") }}</p>
    </div>

    <div class="head">
      <div class="title">{{ detailsObj.withdrawAmount }}</div>
      <div class="money">{{ detailsNewObj.cc }} {{ detailsNewObj.num }}</div>
      <div class="box">
        <img
          class="head-img"
          src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
          alt=""
        />
        <div class="head-txt">{{ detailsNewObj.usd }}</div>
      </div>
    </div>

    <div class="body">
      <div class="body-txt">{{ detailsObj.pntip }}</div>
      <div class="body-box">
        <img class="body-img" :src="detailsObj.pnlogo" alt="" />
        <button @click="go(detailsObj.pnurl)" class="body-btn">
          {{ $t("withdrawalLogin.getAccount") }}
        </button>
      </div>
    </div>

    <div class="pay">
      <span class="payid">{{ detailsObj.pnidMessage }}</span>
      <input
        v-if="detailsObj.pnurl == 'https://www.papara.com/'"
        class="pay-ipt"
        v-model="num"
        type="text"
        oninput="value=value.replace(/[^\d]/g,'')"
        maxlength="10"
      />
      <input v-else class="pay-ipt" v-model="num" type="number" />
      <span v-show="numsta" class="errtxt">{{
        $t("withdrawalLogin.incorrectAccount")
      }}</span>
    </div>

    <div class="pay">
      <span class="payid">{{ detailsObj.whatsAppMessage }}</span>
      <input class="pay-ipt" v-model="id" type="number" />
      <span v-show="idsta" class="errtxt">{{
        $t("withdrawalLogin.Whatsapp")
      }}</span>
      <div class="pay-txt">{{ detailsObj.pnotherTip }}</div>
    </div>

    <button
      :disabled="num == '' ? true : false"
      class="anbtn"
      :class="{ bg: num == '' ? true : false }"
      @click="submit"
    >
      {{ $t("withdrawalLogin.Confirm") }}
    </button>
    <div v-if="changeMate" class="meta">
      <div class="meta-box">
        <van-loading
          v-if="display"
          type="spinner"
          color="#cccccc"
          size="120px"
        />
        <van-icon v-else name="success" size="120px" color="#00d293" />
      </div>
      <div
        v-if="!display"
        v-html="detailsObj.pnreturnMsg"
        class="meta-txt"
      ></div>

      <button @click="returnBtn" class="onBtn">
        {{ $t("roomParty.back") }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Toast } from "vant";
export default {
  name: "picDetails",
  data() {
    return {
      userInfo: [],
      detailsObj: {},
      detailsNewObj: {},
      num: "",
      id: "",
      statusCha: false,
      idsta: false,
      numsta: false,
      uid: "",
      token: "",
      changeMate: false,
      display: true,
      deviceId: '',
    };
  },
  created() {
    this.$i18n.locale = localStorage.getItem("isLang")
    document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    let obj = JSON.parse(this.$route.query.obj);
    this.detailsObj = obj;
    this.detailsObj.pnreturnMsg = this.detailsObj.pnreturnMsg.replace(
      "\n",
      "<br>"
    );
    let newobj = JSON.parse(this.$route.query.newobj);
    this.detailsNewObj = newobj;
    let data = JSON.parse(localStorage.getItem("data"));
    this.uid = data.uid;
    this.token = data.token;
    this.deviceId = data.deviceId;
    this.num = localStorage.getItem("num");
    this.id = localStorage.getItem("id");
  },
  mounted() {
  },
  methods: {
    returnBtn() {
      this.$router.back()
      let active = 0
      localStorage.setItem("active",active);
    },

    go(url) {
      window.location.href = url;
    },

    submit() {
      console.log(this.id);
      if (this.id == "") {
        this.idsta = true;
      } else {
        this.idsta = false;
      }
      if (this.detailsObj.pnurl == "https://www.papara.com/") {
        if (this.num.length < 10) {
          this.numsta = true;
        } else {
          this.numsta = false;
        }
      }
      if (!this.idsta && !this.numsta) {
        console.log(6666);
        this.submitBtn();
      }
    },

    submitBtn() {
      let that = this;
      axios({
        url: that.$serviceIp + `/api/trade/card/tx/applyForWeb`,
        method: "post",
          headers: {
            'deviceId': that.deviceId
          },
        data: {
          cid: that.detailsNewObj.id + "",
          params: { account: that.num, whatsApp: that.id },
        },
        params: { token: that.token, uid: that.uid },
      }).then((res) => {
        if (res.data.code == 200) {
          this.changeMate = true;
          localStorage.setItem("num", that.num);
          localStorage.setItem("id", that.id);
          setTimeout(this.nshbhxbh, 3000);
        } else {
          Toast(res.data.message || this.$t("transfer.error"));
        }
      });
    },
    nshbhxbh() {
      this.display = false;
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

html[lang="ar"] .hound {
  -webkit-transform: rotateY(180deg);
}

html[lang="ar"] .body {
  direction: rtl;
}

html[lang="ar"] .pay {
  direction: rtl;
}

.hound {
  width: 5.9rem;
  height: 0.76rem;
  display: flex;
  align-items: center;
  padding-top: 44px;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
    position:relative;
}

.returns {
  width: 0.54rem;
  height: 0.54rem;
      position:absolute;
}

.hound p {
  flex: 1;
  font-size: 0.31rem;
  text-align: center;
}

.text-right {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
    background-color: #f5f6f8;
}
.head {
  width: 5.98rem;
  height: 2.1rem;
  background: linear-gradient(180deg, #ffffff -6.39%, #fff2d0 100%);
  border-radius: 12px;
  margin-top: 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
}

.title {
  height: 0.3rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 17px;
  color: rgba(123, 124, 132, 1);
}
.money {
  height: 0.53rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 500;
  font-size: 0.44rem;
  line-height: 0.53rem;
  color: #803e39;
}
.box {
  /* height: 0.4rem; */
  display: flex;
  align-items: center;
}
.head-img {
  width: 0.36rem;
  height: 0.36rem;
}
.head-txt {
  height: 0.36rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.3rem;
  line-height: 0.36rem;
  color: #000000;
}

.body {
  width: 5.9rem;
}
.body-txt {
  height: 0.3rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.3rem;
  color: #acadbc;
  margin-top: 0.4rem;
}
.body-box {
  /* height: 0.72rem; */
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.body-img {
  width: 1.79rem;
  height: 0.5rem;
}
.body-btn {
  min-width: 2rem;
  height: 0.68rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 500;
  font-size: 0.27rem;
  color: #ffffff;
  background: #00d293;
  border-radius: 27px;
  border: none;
  padding: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay {
  width: 5.9rem;
  display: flex;
  flex-direction: column;
  margin-top: 0.4rem;
}

.payid {
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 17px;
  color: #000000;
}
.pay-ipt {
  width: 5.9rem;
  height: 0.82rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.27rem;
  line-height: 0.82rem;
  color: #000000;
  /* background: #f3f3f5; */
  border-radius: 12px;
  border: none;
  padding-left: 0.27rem;
  padding-right: 0.27rem;
  box-sizing: border-box;
  margin-top: 0.2rem;
}
.pay-txt {
  height: 0.58rem;
  color: #acadbc;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.29rem;
  margin-top: 0.2rem;
}
.anbtn {
  width: 4.1rem;
  height: 0.82rem;
  background: #00d293;
  border-radius: 24px;
  border: none;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 0.27rem;
  line-height: 0.82rem;
  text-align: center;
  color: #ffffff;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.errtxt {
  font-size: 0.24rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  line-height: 0.29rem;
  color: #ff5c38;
}
.bg {
  color: #acadbc;
  background-color: #f3f3f5;
}

.meta {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.meta-box {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meta-txt {
  width: 85%;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 20px;
  color: #000000;
  text-align: center;
}

.onBtn {
  width: 2.5rem;
  height: 0.82rem;
  font-size: 0.27rem;
  color: #ffffff;
  font-family: PingFang SC;
  border-radius: 12px;
  text-align: center;
  line-height: 0.82rem;
  background-color: #00d293;
  border: none;
  box-sizing: border-box;
  margin-top: 0.6rem;
}
</style>
